<template>
  <div class="w-full flex justify-center pb-16 px-4 sm:px-8 mt-2">
    <div class="w-full max-w-4xl">
      
      <!-- HEADER (Strictly Left Aligned) -->
      <div class="flex flex-col mb-10 pb-6 border-b border-gray-100 text-left w-full items-start animate-fade-in">
        <h1 class="text-3xl sm:text-4xl font-extrabold text-gray-900 tracking-tight mb-3">
          {{ $t("rateYourLevel.ryl1") }}
        </h1>
        <p class="text-gray-500 font-medium text-lg">{{ $t("rateYourLevel.ryl2") }}</p>
      </div>

      <!-- SLIDER CARD -->
      <div class="bg-white rounded-3xl p-8 sm:p-12 border border-gray-100 shadow-sm relative overflow-hidden animate-fade-in-up" style="animation-delay: 0.1s;">
        
        <!-- Slider Section -->
        <div class="flex items-center justify-between w-full mb-12 mt-4 relative z-10" style="direction:ltr">
          
          <!-- "0" Badge -->
          <div class="w-12 h-12 flex-shrink-0 flex items-center justify-center bg-gray-50 text-gray-400 font-extrabold rounded-2xl shadow-sm border border-gray-100 text-lg transition-colors duration-300 hover:text-primary hover:bg-primary/5">
            0
          </div>
          
          <!-- Vuesax Slider -->
          <div class="flex-grow px-4 sm:px-8">
            <vs-slider class="w-full custom-modern-slider" max="10" v-model="your_initial_level" @change="storeInitialLevel" />
          </div>
          
          <!-- "10" Badge -->
          <div class="w-12 h-12 flex-shrink-0 flex items-center justify-center bg-gray-50 text-gray-400 font-extrabold rounded-2xl shadow-sm border border-gray-100 text-lg transition-colors duration-300 hover:text-primary hover:bg-primary/5">
            10
          </div>
          
        </div>

        <!-- Dynamic Status Display -->
        <div class="flex flex-col items-center justify-center mt-6 relative z-10">
          <span class="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4">
            Slide to your level
          </span>
          
          <!-- Dynamic Text Badge -->
          <div class="px-8 py-3 bg-primary/10 text-primary border border-primary/20 font-bold rounded-full text-lg sm:text-xl transition-all duration-300 transform scale-100 shadow-sm text-center">
            {{ initial_level_text }}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RateYourLevel",
  data () {
    return {
      your_initial_level: 0,
      initial_level_text: this.$t("rateYourLevel.ryl3")
    };
  },
  methods: {
    storeInitialLevel () {
      console.log(this.your_initial_level)
      if (this.your_initial_level > 0 && this.your_initial_level <= 2) {
        this.initial_level_text = this.$t("rateYourLevel.ryl4")
      } else if (this.your_initial_level > 2 && this.your_initial_level <= 5) {
        this.initial_level_text = this.$t("rateYourLevel.ryl5")
      } else if (this.your_initial_level > 5 && this.your_initial_level <= 7) {
        this.initial_level_text = this.$t("rateYourLevel.ryl6")
      } else if(this.your_initial_level > 7 && this.your_initial_level < 10){
        this.initial_level_text = this.$t("rateYourLevel.ryl7")
      } else if(this.your_initial_level === 10){
        this.initial_level_text = this.$t("rateYourLevel.ryl8")
      }
      this.$store
        .dispatch("addSkill/setInitialLevel", [this.your_initial_level, this.initial_level_text])
        .then(res => {
          console.log("your initial level", res);
          console.log(
            "store il",
            this.$store.state.addSkill.initialLevel
          );
          console.log(this.initial_level_text)
        })
        .catch(err => {
          console.log("could not set selected competency", err);
        });
    }
  },
  mounted () {
    const initial_level = this.$store.state.addSkill.initialLevel
    console.log(initial_level)
    if (initial_level.length !== 0) this.your_initial_level = initial_level
  }
};
</script>

<style scoped>
/* Base Animations */
.animate-fade-in {
  animation: fadeIn 0.4s ease-out forwards;
  opacity: 0;
}
.animate-fade-in-up {
  animation: fadeInDown 0.5s cubic-bezier(0.25, 1, 0.5, 1) forwards;
  opacity: 0;
}

@keyframes fadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}
@keyframes fadeInDown {
  0% { opacity: 0; transform: translateY(15px); }
  100% { opacity: 1; transform: translateY(0); }
}

/* ------------------------------------- 
   VUESAX SLIDER OVERRIDES
   ------------------------------------- */
/* Makes the Vuesax slider track slightly thicker and more modern */
.custom-modern-slider /deep/ .vs-slider {
  height: 6px !important;
  border-radius: 10px;
}
.custom-modern-slider /deep/ .vs-slider-line {
  height: 6px !important;
}

/* Enhances the draggable circle (thumb) */
.custom-modern-slider /deep/ .vs-slider--circle {
  width: 24px !important;
  height: 24px !important;
  top: -9px !important;
  box-shadow: 0 4px 10px rgba(var(--vs-primary), 0.4) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease !important;
}
.custom-modern-slider /deep/ .vs-slider--circle:hover {
  transform: scale(1.15) !important;
  box-shadow: 0 6px 14px rgba(var(--vs-primary), 0.5) !important;
}

/* Utilities */
.items-left{
  text-align: left;
  text-align: -moz-left;
  text-align: -webkit-left;
}
</style>